
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-new-account",
      function () {
        return require("private-next-pages/create-new-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-new-account"])
      });
    }
  